import React, { createContext, useContext } from 'react';
import { FetchApiHelperFn, FetchOptions, Verb } from '../util/fetchApi';


export type AppConfigurationModules = 'sentry' | 'fetchApi'
export type AppConfiguration = {
  LOGO_SRC?: string,
  APP_NAME?: string,
  AD_CLIENT_ID?: string,
  sentry?: {
    SENTRY_DSN? : string,
  },
  fetchApi?: {
    ENDPOINT?: string,
    defaults?: FetchOptions,
    verbs?: Verb[],
    helpers?: Record<string, FetchApiHelperFn>,
  },
};

export const ConfigurationContext = createContext<AppConfiguration | null>(null);

export function useConfiguration(): AppConfiguration {
  return useContext(ConfigurationContext) ?? {};
};

export const ConfigurationProvider = ({
  children,
  configuration
}: {
  children: React.ReactNode,
  configuration: AppConfiguration
}) => {
  return <ConfigurationContext.Provider value={configuration}>{children}</ConfigurationContext.Provider>;
};
